import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const BackArrowIcon: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 25 25"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2264 1.04294L18.4307 2.24275L8.58827 12.1224L18.4895 22.0424L17.2863 23.2433L6.1875 12.1236L17.2264 1.04294Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default BackArrowIcon;
